<template>
    <div class="flex flex-col min-w-0 break-words w-full mb-6 shadow-md rounded border bg-white">

        <div class="rounded-t mb-0 px-4 py-5 border-b">
            <div class="flex flex-wrap items-center">
                <div class="md:flex-row flex-col relative w-full px-4 inline-flex justify-between max-w-full flex-grow flex-1">
                    <h3 class="font-semibold text-lg">
                        Incentives
                    </h3>
                    <div class="flex flex-row justify-end">
                        <button class="bg-secondary text-white px-10 py-2 font-semibold rounded-md"
                                @click="addIncentiveDialogVisible = true">Add Incentive
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!--    Filters and Search-->
        <div class="flex lg:flex-row flex-col justify-between md:items-start md:space-y-0 space-y-2 md:space-x-4 space-x-0 py-8 px-6 border-b">
            <form>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" class="w-5 h-5 mr-3">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
                        </svg>
                    </div>
                    <input v-model="search"
                           class="block outline-none w-full px-12 py-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-secondary focus:border-secondary"
                           placeholder="Search Incentives ...">
                </div>
            </form>
        </div>

        <div class="block w-full overflow-x-auto">

            <!-- Add/Edit dialog-->
            <el-dialog
                v-model="addIncentiveDialogVisible"
                title="Add/Edit Incentives"
                :width="windowWidth > 768 ? '30%' : '90%'">
                <div class="flex flex-col gap-y-2">
                    <form class="px-4">
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">Type</p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                    <el-select
                                        style="width: 100%" v-model="form.type" placeholder="Select type of incentive" size="default">
                                        <el-option value="rewards">Reward</el-option>
                                        <el-option value="wages">Wage</el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">Details/Name</p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                    <input
                                        class="py-2 text-slate-600 relative bg-white rounded text-sm border border-gray-200 outline-none focus:outline-none focus:border-gray-500 w-full"
                                        v-model="form.details" type="text"
                                        name="form.Distance" required/>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">Amount
                            </p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                    <input
                                        class="py-2 text-slate-600 relative bg-white rounded text-sm border border-gray-200 outline-none focus:outline-none focus:border-gray-500 w-full"
                                        v-model="form.amount" type="number"
                                        name="form.Incentive_Code" required/>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">Needs Authorization</p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                  <el-checkbox v-model="form.needs_authorization">Needs authorization</el-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">Start Date<span
                                    class="text-red-500 ml-2">*</span></p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                    <el-date-picker
                                        size="large"
                                        style="width: 100%"
                                        v-model="form.start_date"
                                        type="date"
                                        placeholder="Pick the date">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col items-start justify-start mb-3 w-full">
                            <p class="text-md font-bold text-sm lg:text-md mb-3">End Date<span
                                    class="text-red-500 ml-2">*</span></p>
                            <div class="flex flex-row items-start justify-start w-full mb-1">
                                <div class="flex flex-row rounded-md w-full">
                                    <el-date-picker
                                        size="large"
                                        style="width: 100%"
                                        v-model="form.end_date"
                                        type="date"
                                        placeholder="Pick the date">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="dialog-footer flex flex-row w-full justify-end px-4">
                        <el-button class="bg-sky-600 text-white" @click="addIncentive">
                            Save
                        </el-button>
                        <el-button class="bg-red-700 text-white" type="danger" @click="addIncentiveDialogVisible = false">
                            Cancel
                        </el-button>
                    </div>
                </div>
            </el-dialog>

            <!--Table-->
            <div class="py-8 px-4">
                <el-table class="" :data="incentives.data" stripe size="large" style="width: 100%">
                    <el-table-column prop="type" label="TYPE"/>
                    <el-table-column prop="amount" label="AMOUNT"/>
                    <el-table-column prop="details" label="DETAILS"/>
                    <el-table-column prop="start_date" label="START DATE"/>
                    <el-table-column prop="end_date" label="END DATE"/>
                    <el-table-column prop="needs_authorization" label="NEEDS AUTH"/>
                    <el-table-column prop="status" label="STATUS"/>
                    <el-table-column prop="created_at" label="CREATED AT"/>
                    <el-table-column label="ACTIONS">
                        <template #default="scope">
                            <el-dropdown size="large">
                                <el-button>
                                    Actions
                                    <el-icon class="el-icon--right">
                                        <arrow-down/>
                                    </el-icon>
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item @click.native="updateIncentive(scope.row)">EDIT</el-dropdown-item>
                                        <el-dropdown-item @click.native="deleteIncentive(scope.row)">DELETE
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="flex flex-row p-5 w-full justify-end">
                <el-pagination
                    :current-page="incentives.current_page"
                    :page-size="incentives.per_page"
                    :page-sizes="[5,10,20,50]"
                    :small=false
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="incentives.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
            </div>
        </div>

    </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {ArrowDown} from '@element-plus/icons-vue'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    data() {
        return {
            search: '',
            uploadIncentiveDialogVisible: false,
            addIncentiveDialogVisible: false,
            windowWidth: window.innerWidth,
            form: {},
            incentive: {},
            filters: {
                paginate: true,
                per_page: 10
            },
        };
    },
    components: {
        ArrowDown

    },
    mounted() {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.getIncentivesList({
            ...this.filters,
            id: this.$route.params.id ? this.$route.params.id : this.user.user_company?.company_id
        })
    },
    computed: {
        ...mapGetters({
            incentives: 'incentives/incentives',
        })
    },
    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.getIncentivesList(this.filters)
            }
        },
        search: function (val) {
            this.getIncentivesList({
                ...this.filters,
                search: val
            });
        }
    },
    methods: {
        ...mapActions({
            getIncentivesList: 'incentives/getIncentives',
            createIncentives: 'incentives/createIncentives',
            editIncentive: 'incentives/editIncentive',
            deleteIncentive:'incentives/deleteIncentive'
        }),
        handleSizeChange(size) {
            this.filters.per_page = size;
            this.getIncentivesList({paginate: true, ...this.filters});
        },
        handleCurrentChange(page) {
            this.filters.page = page;
            this.getIncentivesList({paginate: true, ...this.filters});
        },
        addIncentive() {
            this.form.company_id = this.$route.params.id ? this.$route.params.id : this.user.user_company?.company_id
            if (this.form.id) {
                this.editIncentive(this.form).then(() => {
                    if (!this.has_errors) {
                        this.form = {}
                        this.addIncentiveDialogVisible = false
                    }
                })
            } else {
                this.createIncentives(this.form).then(() => {
                    if (!this.has_errors) {
                        this.form = {}
                        this.addIncentiveDialogVisible = false
                    }
                });
            }
        },
        updateIncentive(item) {
            this.addIncentiveDialogVisible = true
            this.form = Object.assign({}, this.form, item);
        },
        deleteIncentive() {

        },

    }
};
</script>
<style scoped>
.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: transparent;
    display: flex;
    align-items: center;
}
</style>
